/**
 * DANGER ZONE
 * Vide les donnees risques apres saisie d'un code : l'etablissement en multi, tout le compte en mono
 */
import { t } from "i18next"
import { useState } from "react"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import Card from "@/components/card"
import Button from "@/components/button"
import Modal from "@/components/modal"
import Space from "@/components/space"
import EnterCodeWidget from "@/widgets/enter-code.widget"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { STATUS_LOADED, STATUS_SAVING } from "@/redux/_status.types"
import establishmentStore from "../model/establishment.store"

export default function EstablishmentClearData() {
  const dispatch = useAppDispatch()
  const establishment = useAppSelector(establishmentStore.selectors.active)
  const isMultiple = useAppSelector((state) => state._session.accountRisksSettings.allowMultipleEstablishments)
  //En mono-etablissement, familles et baremes du compte partent aussi
  const scope = isMultiple
    ? "Toutes les données risques de l'établissement."
    : "Toutes les données risques, familles et barèmes compris."
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [status, setStatus] = useState(STATUS_LOADED)

  async function handleConfirm() {
    setStatus(STATUS_SAVING)
    const response: any = await dispatch(establishmentStore.thunks.clearData())
    setStatus(STATUS_LOADED)
    if (response.payload?.error) return

    setIsModalOpen(false)
    toast(t("Les données de l'établissement ont été supprimées"))
  }

  return (
    <Card>
      <div className="flex items-center gap-6">
        <div>
          <div className="mb-4 flex items-center gap-3">
            <FontAwesomeIcon icon={faTriangleExclamation} className="grey-t text-lg" />
            <span className="text-lg">{t("Supprimer les données")}</span>
          </div>
          <div className="grey-t">{t(scope)}</div>
        </div>
        <Space />
        <Button className="warning" classNameCustom="shrink-0 whitespace-nowrap" onClick={() => setIsModalOpen(true)}>
          {t("utils_delete")}
        </Button>
      </div>

      {isModalOpen && (
        <Modal onClose={() => setIsModalOpen(false)} title={`Supprimer les données de “${establishment.name}”`}>
          <div className="space-y-4 text-neutral-800">
            <p>
              <b>{t(scope)}</b>
            </p>

            <p className="text-sm red-t">{t("Cette action est irréversible.")}</p>

            <Space />

            <EnterCodeWidget onCancel={() => setIsModalOpen(false)} onNext={handleConfirm} status={status} />
          </div>
        </Modal>
      )}
    </Card>
  )
}
